export const formatStudyNameWithSide = (
  name: string,
  side?: string | null,
): string => {
  return side ? `${name} (${side})` : name;
};
